import React from 'react';

const Envelope = () => (
    <svg width="32" height="27" viewBox="0 0 32 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5332 7.29998L15.9999 15.5666L30.4665 7.29998M3.59987 1.09998H28.3999C29.5413 1.09998 30.4665 2.02525 30.4665 3.16664V23.8333C30.4665 24.9747 29.5413 25.9 28.3999 25.9H3.59987C2.45848 25.9 1.5332 24.9747 1.5332 23.8333V3.16664C1.5332 2.02525 2.45848 1.09998 3.59987 1.09998Z" stroke="#4B5661" strokeWidth="1.6"/>
    </svg>
)

export default Envelope